import { noop } from 'lodash';
import { type ReactNode } from 'react';
import { Form } from 'react-final-form';

type OnSubmit<T> = (values?: T) => void | Promise<void>;

type WithFormProps<T> = {
  children: ReactNode;
  initialValues: T;
  onSubmit?: OnSubmit<T>;
};

// To update! Not a HOC
export const WithForm = <T,>({ children, initialValues, onSubmit }: WithFormProps<T>) => {
  return (
    <Form onSubmit={onSubmit ?? noop} initialValues={initialValues}>
      {() => children}
    </Form>
  );
};
